import { render, staticRenderFns } from "./Role-Item.vue?vue&type=template&id=a0b82112&"
import script from "./Role-Item.vue?vue&type=script&lang=ts&"
export * from "./Role-Item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports